import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/location-types',
			exact: true,
			component: Page.Layout
		},
	]
};